// export const API_BASE_PATH = '/api/';
export const API_BASE_PATH = 'http://1.94.40.158:9111/';
// export const API_BASE_PATH = 'http://1.94.40.158:9112/'; 
// export const API_BASE_PATH = 'http://115.120.243.87:17013/'; //对应9111
// export const API_BASE_PATH = 'http://183.249.91.105:19083/';
// export const API_BASE_PATH = 'http://115.120.243.87:17014/'; //对应9112
// export const API_BASE_PATH = 'http://192.168.0.100:9111/';
// export const API_BASE_PATH = 'http://123.60.22.89:9111/';

// 搜索栅格
export const SEARCH_ITEM_COL = { xs: 24, md: 12, xl: 8, xxl: 6 };
export const SEARCH_ITEM_GUTTER = { sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 };

// 表单栅格
export const FORM_ITEM_COL = { xs: 24, md: 12, xl: 8 };
export const FORM_ITEM_GUTTER = { md: 24, lg: 32 };

// for pages
export const TABLE_DATA_DEFAULT = { total: 0, rows: [] };

// for cookie
export const COOKIE_TOKEN = 'cookieToken';

// for form
export const FORM_RULE_REQUIRED = { required: true, message: '该项为必填项' };
